import { FormGroup, Validators } from '@angular/forms';

import { EventValidationAction } from './event-validation-action.enum';
import { FieldValidatorsMap, FormValidatorsMap } from '../interfaces';

import { ObjectLike } from 'app/interfaces';
import { FormModel } from 'app/models';
import { requiredWithout } from 'app/validators';

export class EventDiscountRules extends FormModel<EventValidationAction> {
    baseValidators: FieldValidatorsMap = {
        name: [Validators.required],
        usergroup: [Validators.required],
        selectedUsergroupId: [Validators.required],
        eventId: [Validators.required],
        value: [Validators.required],
        amount: [Validators.min(0), requiredWithout(['infiniteChecked'])],
        type: [Validators.required],
        validUntil: [],
    };
    formValidators: FormValidatorsMap = {};

    getStoreForm(formFrom: ObjectLike = {}): FormGroup {
        return this.createFormGroup(EventValidationAction.StoreDiscount, formFrom);
    }
}
